import React, { useEffect, useState } from 'react';
import styles from './filter-by-menu.module.css';
import classNames from 'classnames';
import MenuList from '../menu-list/menu-list';
export function FilterByMenu(props) {
    var _a = useState(), selectedItem = _a[0], setSelectedItem = _a[1];
    var _b = useState(), longestItem = _b[0], setLongestItem = _b[1];
    useEffect(function () {
        if (!!props.defaultItem)
            setSelectedItem(props.defaultItem);
    }, [props.defaultItem]);
    useEffect(function () {
        setLongestItem(props.items.reduce(function (a, b) { return (a.text.length > b.text.length ? a : b); }).text);
    }, [props.items]);
    return (React.createElement(MenuList, { onSelect: setSelectedItem, items: props.items }, function (_a) {
        var _b;
        var openMenu = _a.openMenu, setButtonRef = _a.setButtonRef, isOpen = _a.isOpen;
        return (React.createElement("button", { className: classNames(styles.filterByMenuButton, "kplr_filterByMenuButton"), ref: setButtonRef, onClick: openMenu },
            React.createElement("div", { className: styles.filterByMenuPlaceholderLabel },
                "Filter by: ",
                longestItem),
            React.createElement("div", { className: classNames(styles.filterByMenuPlaceholderLabel, styles.filterByMenuLabel) },
                "Filter by: ",
                selectedItem),
            React.createElement("u", { className: classNames(styles.filterButtonArrow, (_b = {}, _b[styles.isOpen] = isOpen, _b)) })));
    }));
}
export default FilterByMenu;
